import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSelect = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M2.147,2.096l6.138,19.809l4.557,-7.626l9.011,-2.874l-19.706,-9.308Z",
		style: {
			fill: "none",
			fillRule: "nonzero",
			stroke: "currentColor",
			strokeWidth: "1.5px"
		}
	}) })
});
export default SvgSelect;
